import { useState } from 'react'
import { CheckCircle2, ShieldCheck } from 'lucide-react'
import clsx from 'clsx'

export default function FirmaEmisionMasiva({ onEmit }) {
  const [accepted, setAccepted] = useState(false)

  const handleEmitClick = () => {
    if (!accepted) return
    onEmit()
  }

  return (
    <div className='mt-0 mb-4 flex flex-col items-center justify-center'>
      <div className='rounded-2xl border border-blue-100 bg-blue-50/20 p-4 shadow-sm'>
        <div className='flex flex-col items-center text-center'>
          <div className='mb-1.5 flex h-8 w-8 items-center justify-center rounded-xl bg-primary text-white shadow-sm'>
            <ShieldCheck size={18} />
          </div>

          <h3 className='text-sm font-bold text-slate-900'>Confirmación de emisión</h3>
        </div>

        <div className='mt-1 rounded-xl bg-white p-2.5 border border-slate-100 shadow-sm'>
          <label className='flex cursor-pointer items-center gap-3'>
            <div className='relative flex items-center shrink-0'>
              <input
                type='checkbox'
                checked={accepted}
                onChange={e => setAccepted(e.target.checked)}
                className='peer h-4.5 w-4.5 cursor-pointer appearance-none rounded-md border-2 border-slate-300 transition-all checked:border-primary checked:bg-primary'
              />
              {/* <CheckCircle2
                size={12}
                className='pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white opacity-0 transition-opacity peer-checked:opacity-100'
              /> */}
            </div>
            <span className={clsx(
              'text-[0.85rem] font-medium transition-colors',
              accepted ? 'text-slate-900' : 'text-slate-600'
            )}>
              He revisado los documentos y autorizo su emisión al SII.
            </span>
          </label>
        </div>

        <div className='mt-2 flex justify-center'>
          <button
            type='button'
            onClick={handleEmitClick}
            disabled={!accepted}
            className={clsx(
              'flex items-center gap-2 rounded-full text-white text-sm px-4 py-2 shadow hover:shadow-lg hover:bg-opacity-90',
              accepted
                ? 'bg-accent2 hover:bg-accent2/80 hover:shadow-lg active:scale-95'
                : 'bg-slate-300 cursor-not-allowed opacity-70'
            )}
          >
            <span>Confirmar emisión</span>
            <CheckCircle2 size={13} className='transition-transform group-hover:scale-110' />
          </button>
        </div>
      </div>
    </div>
  )
}